'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
require('../../../../theme/Shadows.cjs.js');
require('../../../../theme/Typography.cjs.js');
require('react');
const theme_LegacyColorMap = require('../../../../theme/LegacyColorMap.cjs.js');
require('../../SubscriptionForm/SubscriptionForm.cjs.js');
const components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer = require('../../SubscriptionForm/SubscriptionFormWithDisclaimer.cjs.js');
require('../../SubscriptionForm/DisclaimerText.cjs.js');
const components_navigation_Button_Button = require('../../../navigation/Button/Button.cjs.js');
const components_navigation_DarkBackgroundButton_DarkBackgroundButton = require('../../../navigation/DarkBackgroundButton/DarkBackgroundButton.cjs.js');
const components_marketing_CTA_CTATextContent = require('../CTATextContent.cjs.js');
const components_marketing_CTA_utils = require('../utils.cjs.js');
const styleMixins_reset = require('../../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("CTACentered", {
  root: (backgroundColor) => react.css`
    ${styleMixins_reset.boxSizing};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 30px;
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[backgroundColor]]};

    @media screen and (min-width: 768px) {
      padding: 40px;
    }

    @media screen and (min-width: 1230px) {
      padding: 70px 200px;
    }
  `,
  mediaContent: (maxWidth) => react.css`
    ${styleMixins_reset.boxSizing};
    max-width: ${maxWidth}px;
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `
});
const getSubscriptionFormButton = (bgColor, ctaBtnColor) => {
  const btnColor = components_marketing_CTA_utils.getCtaBtnColor(bgColor, ctaBtnColor);
  const btnProps = {
    children: "Submit",
    size: "medium",
    type: "submit"
  };
  if (btnColor === "primary-dark")
    return react.jsx(components_navigation_DarkBackgroundButton_DarkBackgroundButton.DarkBackgroundButton, Object.assign({}, btnProps));
  else {
    return react.jsx(components_navigation_Button_Button.Button, Object.assign({}, btnProps, {
      // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
      color: btnColor === "primary-alt" ? "primary" : btnColor,
      size: "small"
    }));
  }
};
const CTACentered = ({ backgroundColor = "neutral100", ctaHref, ctaBtnColor, ctaText, description, heading, maxWidth = 570, onCtaClick, onCtaKeyDown, subHeading, isSubscriptionForm, subscriptionPlaceholder, onSubscriptionFormSubmit, ctaTarget }) => {
  const bgColor = components_marketing_CTA_utils.getBgColor(backgroundColor);
  const isZapierOrange = bgColor === "zapier";
  if (isZapierOrange && isSubscriptionForm) {
    console.error("Do not use the subscription form with the zapier background. The disclaimer text accessibility is poor on the zapier background.");
  }
  return react.jsx(
    "div",
    { css: Styles.root(bgColor), "data-zds": true },
    react.jsx(
      "div",
      { css: Styles.mediaContent(maxWidth), "data-zds": true },
      react.jsx(components_marketing_CTA_CTATextContent.CTATextContent, { heading, subHeading, description, ctaText: !isSubscriptionForm ? ctaText : void 0, ctaHref: !isSubscriptionForm ? ctaHref : void 0, ctaBtnColor, onCtaClick: !isSubscriptionForm ? onCtaClick : void 0, onCtaKeyDown, bgColor, alignment: "center", ctaTarget })
    ),
    isSubscriptionForm ? react.jsx(components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer.SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder || "", renderButton: () => getSubscriptionFormButton(backgroundColor, ctaBtnColor), onSubmit: onSubscriptionFormSubmit, disclaimerTextColor: bgColor === "neutral100" ? "primary" : "secondary", disclaimerTextType: "Body1" }) : null
  );
};

exports.CTACentered = CTACentered;
//# sourceMappingURL=CTACentered.cjs.js.map
